var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"f-ava"},[_c('img',{staticClass:"f-ava__img",attrs:{"src":'https://chat.iqquantum.com/avatar/' + _vm.userLogin + '?dc_'+new Date().getMilliseconds()}})])}
var staticRenderFns = []

export { render, staticRenderFns }